<script lang="ts" setup>
import DiagnoseButton from './DiagnoseButton.vue';
import type { KvImageSrcset } from './kvImageSrcsets';
import { getMaxSizeSrc, getSrcsetString } from './kvImageSrcsets';
import KvBottomCover from './kv_bottom_cover.svg?component';
import { mobileMaxWidth } from 'theme/assets/styles/export.module.scss';

const props = defineProps<{
  kvImageSrcset: KvImageSrcset;
}>();
</script>

<template>
  <div :class="$style.container">
    <div :class="$style.wrapper">
      <div :class="[$style.wrapper__block, $style.block]">
        <p :class="[$style.block__heading, $style.heading]">
          <slot name="heading" />
        </p>
        <div :class="[$style.block__title, $style.title]">
          <slot name="title" />
        </div>
        <p :class="[$style.block__description, $style.description]">
          <slot name="description" />
        </p>
        <DiagnoseButton :class="[$style.block__button, $style.button]" />
      </div>
      <img
        :src="getMaxSizeSrc(props.kvImageSrcset)"
        :srcset="getSrcsetString(props.kvImageSrcset)"
        :sizes="`(max-width: ${mobileMaxWidth}) 380px, 600px`"
        :class="[$style.wrapper__kv, $style.kv]"
        width="600"
        height="480"
      />
    </div>
    <KvBottomCover
      :class="[$style.container__kvBottomCover, $style.kvBottomCover]"
    />
  </div>
</template>

<style lang="scss" module>
.container {
  position: relative;
  overflow: hidden;
}

.wrapper {
  display: flex;
  justify-content: center;
  gap: 90px;
  padding: 90px 90px 0 90px;
  background: linear-gradient(to right, $color-blue-200, #f8fcff);

  @include mobile-only {
    flex-direction: column;
    align-items: center;
    gap: 22px;
    padding: 24px 16px 0px 16px;
  }
  @include tablet-only {
    flex-direction: column;
    align-items: center;
    gap: 22px;
    padding: 24px 16px 0px 16px;
  }
}

.block {
  margin-top: 24px;
  max-width: 400px;
  min-width: 340px;

  @include mobile-only {
    margin-top: 0px;
  }
  @include tablet-only {
    margin-top: 0px;
  }
}

.heading {
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  line-height: 36px;
  border-radius: 1em;
  color: $color-text-and-object-high-emphasis-inverse;
  background-color: $color-surface-accent-primary;
}

.title {
  margin-top: 16px;
  text-align: center;
  font-weight: 900;

  @include mobile-only {
    margin-top: 8px;
  }
  @include tablet-only {
    margin-top: 8px;
  }
}

.description {
  margin-top: 16px;
  font-size: 14px;
  line-height: 25.2px;

  color: $color-text-and-object-high-emphasis;
  @include mobile-only {
    margin-top: 8px;
  }
  @include tablet-only {
    margin-top: 8px;
  }
}

.button {
  width: 100%;
  margin: auto;
}

.kv {
  max-width: 600px;

  @include mobile-only {
    max-width: 380px;
  }
}

.kvBottomCover {
  position: absolute;
  display: block;
  height: 120px;
  left: 50%;
  bottom: -4px;
  width: 100%;
  transform: translateX(-50%);
  min-width: 680px;
}
</style>
